import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { resolvePrimaryFacilityImageUrl } from '../../../modules/assets';
import FormFieldText from '../FormFieldText';
import styles from './styles.scss';

const propTypes = {
  defaultAlt: PropTypes.string.isRequired,
};

const defaultProps = {};

const DefaultPrimaryImageForm = ({
  defaultAlt,
}) => (
  <Row>
    <Col xs={5}>
      <>
        <img
          alt={defaultAlt}
          className={styles.image}
          src={resolvePrimaryFacilityImageUrl()}
        />
      </>
    </Col>
    <Col xs={7}>
      <FormFieldText
        label="Alt Text"
        name="defaultPrimaryImageAlt"
        value={defaultAlt}
        data-testid="form-field-medium-alt"
        disabled
      />
      <FormFieldText
        label="Title Text"
        name="defaultPrimaryImageTitle"
        disabled
      />
    </Col>
  </Row>
);

DefaultPrimaryImageForm.propTypes = propTypes;
DefaultPrimaryImageForm.defaultProps = defaultProps;

export default DefaultPrimaryImageForm;
